import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex items-center gap-2"
};
const _hoisted_2 = {
  key: 1,
  class: "text-gray-700 text-sm"
};
import { computed } from 'vue';
export default {
  __name: 'LlUserAvatar',
  props: {
    account: {
      type: Object,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    initials: {
      type: String,
      default: null
    },
    emptyValue: {
      type: String,
      default: '—'
    }
  },
  setup(__props) {
    const props = __props;
    const displayInitials = computed(() => {
      if (props.initials) return props.initials;
      if (props.account?.initials) return props.account.initials;
      return null;
    });
    const displayName = computed(() => {
      if (props.name) return props.name;
      if (props.account?.name) return props.account.name;
      return props.emptyValue;
    });
    return (_ctx, _cache) => {
      const _component_v_avatar = _resolveComponent("v-avatar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [displayInitials.value ? (_openBlock(), _createBlock(_component_v_avatar, {
        key: 0,
        size: "24",
        color: "green-lighten-1",
        class: "text-white text-xs"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(displayInitials.value), 1)]),
        _: 1
      })) : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(displayName.value), 1))]);
    };
  }
};